import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

const AIStudioPage = () => {
  const { theme } = useTheme();

  return (
    <>
      <Helmet>
        <title>AI Studio | BookMyAudition</title>
      </Helmet>
      <div 
        className="ai-studio-page" 
        style={{ 
          minHeight: '70vh', 
          padding: '60px 0',
          backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc',
          color: theme === 'dark' ? '#f8fafc' : '#111'
        }}
      >
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4" style={{ color: theme === 'dark' ? '#fff' : '#111' }}>
                AI Studio
              </h1>
              <p style={{ color: theme === 'dark' ? '#cbd5e1' : '#475569', fontSize: '1.1rem' }}>
                Revolutionary AI tools designed for the modern actor. From AI-driven script analysis to virtual practice partners, elevate your craft with technology.
              </p>
              
              <div 
                className="coming-soon-box mt-5 p-5 rounded-4 shadow-sm"
                style={{
                  backgroundColor: theme === 'dark' ? '#111116' : '#fff',
                  border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}`
                }}
              >
                <div 
                  className="d-inline-block mb-3 px-3 py-1 rounded-pill" 
                  style={{ 
                    backgroundColor: 'rgba(99, 102, 241, 0.1)', 
                    color: '#6366f1',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    border: '1px solid rgba(99, 102, 241, 0.2)'
                  }}
                >
                  NEXT GEN TECH
                </div>
                <h3 className="fw-bold mb-3">AI Studio is Arriving Soon</h3>
                <p className="mb-0 text-muted">
                  We are building powerful AI features like automated monologue feedback and background removal for self-tapes. Stay tuned for the future of auditioning!
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AIStudioPage;